import React, { use, useEffect, useState } from "react";
import EventSeriesCard from "./EventSeriesCard";
import { Link } from "react-router-dom";
import { useContext } from "react";
import { DataContext } from "../../providers/DataProvider";
import AddPlusCard from "../modal/AddPlusCard";
import ModalCreate from "../modal/ModalCreate";
import { DataHandlerContext } from "../../providers/DataHandlerProvider";
function Dashboard() {
  const {
    eventSeriesData,
    loading,
    error,
    numbOfEvents,
    numbOfSignups,
    nextEventIn,
    getNumbOfEvents,
    markFormObject,
    markFormTotalSignups,
    setEventSeriesData,
    setMarkFormObject,
  } = useContext(DataContext);

  const { addEventSeries, addMarkForms } = useContext(DataHandlerContext);

  const [showModalForm, setShowModalForm] = useState(false);
  const [showModalEventsSeries, setShowModalEventsSeries] = useState(false);

  const openModalEvent = (type) => {
    setShowModalEventsSeries(true);
  };

  const openModalForm = () => {
    setShowModalForm(true);
  };
  const closeModal = () => {
    setShowModalForm(false);
    setShowModalEventsSeries(false);
  };

  useEffect(() => {}, [showModalForm, showModalEventsSeries]);

  useEffect(() => {
    console.log("Mark Form Object:", markFormObject);
  }, [setMarkFormObject]);
  
  useEffect(() => {
    //console.log("Event Series Data:", eventSeriesData);
    getNumbOfEvents();
  }, [eventSeriesData]);

  return (
    <div className="flex flex-col min-h-screen  ">
      <div className="flex justify-between align-middle lg:px-[10rem] p-[2rem] pt-[5rem]   items-center md:space-x-4">
        <p className="text-5xl font-extrabold">Events Hub</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6 lg:px-[10rem] p-[2rem]">
        {eventSeriesData.map((series, key) => (
          <Link to={`/${series.title.toLowerCase().replace(/\s+/g, "-")}/events-series/${series.id}`}>
            <EventSeriesCard
              index={key}
              key={series.id}
              eventTitle={series.title}
              eventCount={numbOfEvents[series.id]}
              nextEventIn={nextEventIn[series.id]}
              numbOfSignups={numbOfSignups[series.id]}
            />
          </Link>
        ))}
        <AddPlusCard
          eventTitle={"Add event serie"}
          openModal={openModalEvent}
        />

        {showModalEventsSeries && (
          <ModalCreate
            title="Create a new Event Series"
            subTitle="Please enter the title"
            inputName="title"
            closeModal={closeModal}
            addFunct={addEventSeries}
            mainSetter={setEventSeriesData}
          />
        )}
      </div>
      <div className="flex justify-between align-middle lg:px-[10rem] p-[2rem]   items-center md:space-x-4">
        <p className="text-5xl font-extrabold">Form</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6 lg:px-[10rem] p-[2rem]">
        {markFormObject.map((markFormCard, key) => (
          <Link
            to={`/${markFormCard.title
              .toLowerCase()
              .replace(/\s+/g, "-")}/form/${markFormCard.id}`}
          >
            <EventSeriesCard
              type={"form"}
              index={key}
              key={markFormCard.id}
              eventTitle={markFormCard.title}
              numbOfSignups={markFormTotalSignups[markFormCard.id]??0}
            />
          </Link>
        ))}

        <AddPlusCard eventTitle={"Add form"} openModal={openModalForm} />
        {showModalForm && (
          <ModalCreate
            title="Create a new Form"
            subTitle="Please enter the title"
            inputName="title"
            closeModal={closeModal}
            addFunct={addMarkForms}
            mainSetter={setMarkFormObject}
          />
        )}
      </div>
    </div>
  );
}

export default Dashboard;
